import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadStateTransitions(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    const flags = getState().document.stateTransitions[key];
    if (flags?.loading || flags?.loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_STATE_TRANSITIONS_STARTED, id: key });
      const stateTransitions = await dispatch(sendHttpRequest(api.loadStateTransitions(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_STATE_TRANSITIONS_SUCCESS, payload: stateTransitions, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
